// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentChoice_wrapper__0wOxs","list":"PaymentChoice_list__7CRrr","bold":"PaymentChoice_bold__nhmBb","big":"PaymentChoice_big__+K5nC"};